<template>
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 16 16" style="enable-background:new 0 0 16 16;" xml:space="preserve" class="svg-checkmark" >

<g>
	<path class="svg-primary-color" d="M5.4,11L2.6,8.2c-0.3-0.3-0.8-0.3-1.1,0l0,0C1.2,8.5,1.2,9,1.5,9.3l3.2,3.2c0.4,0.4,1,0.4,1.4,0l8.4-8.4
		c0.3-0.3,0.3-0.8,0-1.1l0,0c-0.3-0.3-0.8-0.3-1.1,0L5.4,11z M5.4,11" />
</g>
</svg>

</template>

<script>
    export default {
        name: "radialProgress",
    }
</script>

<style scoped>
    svg {
        width: 16px;
        height:16px;
    }
</style>



// WEBPACK FOOTER //
// src/common/components/svg/productList/radialProgress.vue